import { render, staticRenderFns } from "./Form31PDFTranslate.vue?vue&type=template&id=a2f0210c&scoped=true&"
import script from "./Form31PDFTranslate.vue?vue&type=script&lang=js&"
export * from "./Form31PDFTranslate.vue?vue&type=script&lang=js&"
import style0 from "./Form31PDFTranslate.vue?vue&type=style&index=0&id=a2f0210c&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "a2f0210c",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VCheckbox } from 'vuetify/lib/components/VCheckbox';
import { VFlex } from 'vuetify/lib/components/VGrid';
import { VLayout } from 'vuetify/lib/components/VGrid';
installComponents(component, {VCheckbox,VFlex,VLayout})
